export default __webpack_public_path__ + "static/media/gallery_13.83ccc6e5.jpg";